import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import { Messages } from '../../../codegen/Localize';
import { showResumeRunFlowTasksActionDialog } from '../../../flow/actions/ResumeRunFlowTasksAction';
import { RunFlowTaskInfo } from '../../../ts/models/RunFlowTaskInfo';
import { Set } from '../../../ts/models/Set';
import { ChangeRunFlowTasksPriorityAction } from '../../../ts/services/ChangeRunFlowTasksPriorityAction';
import { ChangeScheduleActionService } from '../../../ts/services/ChangeScheduleAction';
import { RunFlowTasksAction } from '../../../ts/services/RunFlowTasksAction';
import { RunFlowTaskChangePriority, RunFlowTaskChangeSchedule, RunFlowTaskResume, RunFlowTaskRunNow } from '../../actions/AppActionTypes';
import { requestFailed } from '../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../actions/spaces/RequestSpaceContentsActions';
import { RunFlowTaskMenuAction } from '../../actions/spaces/RunFlowTaskMenuActions';
import { ServiceLocator } from '../../ServiceLocator';

export function* handleRunNow(action: RunFlowTaskMenuAction) {
  try {
    yield call(runNow, action.items);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function runNow(runFlowTasks: RunFlowTaskInfo[]) {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<RunFlowTasksAction>('RunFlowTasksAction')
    .execute(Set.fromIdItemArray(runFlowTasks), context);
}

export function* handleChangeSchedule(action: RunFlowTaskMenuAction): SagaIterator {
  try {
    yield call(changeSchedule, action.items);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function changeSchedule(runFlowTasks: RunFlowTaskInfo[]) {
  const context = ServiceLocator.getAngularActionContext();
  return ChangeScheduleActionService.forRunFlowTasks(Set.fromIdItemArray(runFlowTasks), context);
}

export function* handleChangePriority(action: RunFlowTaskMenuAction): SagaIterator {
  try {
    yield call(changePriority, action.items);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function changePriority(runFlowTasks: RunFlowTaskInfo[]) {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<ChangeRunFlowTasksPriorityAction>('ChangeRunFlowTasksPriorityAction')
    .execute(Set.fromIdItemArray(runFlowTasks), context);
}

export function* handleResume(action: RunFlowTaskMenuAction): SagaIterator {
  try {
    yield call(resume, action.items);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function resume(runFlowTasks: RunFlowTaskInfo[]) {
  return showResumeRunFlowTasksActionDialog(Set.fromIdItemArray(runFlowTasks));
}

export function* rootRunFlowTaskMenuActionSaga(): SagaIterator {
  yield takeEvery(RunFlowTaskRunNow, handleRunNow);
  yield takeEvery(RunFlowTaskChangeSchedule, handleChangeSchedule);
  yield takeEvery(RunFlowTaskChangePriority, handleChangePriority);
  yield takeEvery(RunFlowTaskResume, handleResume);
}
